import React from 'react';
import { GECKO_CONSTS, GeckoFields } from 'ui';
import {
  convertRawOptionsToJson,
  selectDefaultsMatchingOptions,
} from './logic';

const MultiEntryOptionsList = ({
  rawOptions,
  options = [],
  updateState: updateParentState,
  defaultValues: propDefaultValues,
  type: selectFieldType,
  swapModeButton,
}) => {
  const convertBackToRealValues = () => {
    if (Array.isArray(propDefaultValues)) {
      return propDefaultValues.map((value) =>
        options.find((option) => option.id === value)
      );
    } else {
      return options.find((option) => option.id === propDefaultValues);
    }
  };
  const realDefaultValues = convertBackToRealValues();

  const handleChange = (key, value) => {
    if (key === 'default_value') {
      return updateParentState(rawOptions, value);
    }

    const optionsList = convertRawOptionsToJson(value);
    const defaultsMatchingOptions = selectDefaultsMatchingOptions(
      selectFieldType,
      optionsList,
      propDefaultValues
    );
    return updateParentState(value, defaultsMatchingOptions);
  };

  const renderOptionInput = () => {
    return [
      {
        key: 'raw_options',
        required: true,
        type: GECKO_CONSTS.FIELD_TYPE_TEXTAREA,
        width: '100%',
      },
      swapModeButton,
      {
        key: 'raw_options',
        type: GECKO_CONSTS.FIELD_TYPE_DISPLAY,
        render: () => {
          return (
            <span role="complementary">
              <p>
                Put each of your options on a new line. If you need your option
                to have a different value for your integration(s), write your
                option like:
              </p>

              <code>Label|value</code>
            </span>
          );
        },
        width: '100%',
      },
    ];
  };

  const renderDefaultValueInput = () => {
    return [
      {
        label: 'Default Value',
        key: 'default_value',
        description:
          'If set any new Contacts that are created without this field filled in will be given this default value',
        type: selectFieldType,
        options,
        width: '100%',
      },
    ];
  };

  const renderFields = () => [
    ...renderOptionInput(),
    ...renderDefaultValueInput(),
  ];
  return (
    <div className="MultiEntryOptionsList">
      <GeckoFields
        handler={handleChange}
        values={{ raw_options: rawOptions, default_value: realDefaultValues }}
        fields={renderFields()}
      />
    </div>
  );
};

export default MultiEntryOptionsList;
